import z from 'zod';
import { documentsSchema } from './zodSchema';

type Documents = z.infer<typeof documentsSchema>;

export const validateRequiredDocuments = (documents: Documents) => {
  const missingDocs = documents.filter((doc) => doc.required && !doc.documentUrl);

  return {
    isValid: missingDocs.length === 0,
    missingDocs,
  };
};
export const extractFileName = (url: string) => {
  try {
    return url.split('/').pop() ?? '';
  } catch {
    return '';
  }
};

export const formatDateTime = (dateString: string) => {
  if (!dateString) return '';

  const normalized = dateString.replace(' pm', ' PM').replace(' am', ' AM');

  const date = new Date(normalized);

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }).format(date);
};
